/* Ribel - pattern PDP (portato da Performa): sfondo sfocato, barra ATC mobile, zoom touch, conferma carrello. */
(function () {
  var isTouch = window.matchMedia("(hover:none),(pointer:coarse)").matches;
  var onPDP = !!document.querySelector("media-gallery");

  /* ---------- 1. sfondo sfocato dietro ogni foto ---------- */
  function paintBlur() {
    document.querySelectorAll("media-gallery .product-media-container").forEach(function (c) {
      var img = c.querySelector("img");
      if (!img) return;
      var src = img.currentSrc || img.src;
      if (!src) return;
      var b = c.querySelector(".rbl-blurbg");
      if (!b) { b = document.createElement("span"); b.className = "rbl-blurbg"; c.insertBefore(b, c.firstChild); }
      if (b.getAttribute("data-src") !== src) { b.setAttribute("data-src", src); b.style.backgroundImage = "url(\"" + src + "\")"; }
    });
  }
  function watchBlur() {
    if (!onPDP) return;
    paintBlur();
    document.querySelectorAll("media-gallery img").forEach(function (im) {
      if (!im.complete) im.addEventListener("load", paintBlur, { once: true });
    });
    var host = document.querySelector("media-gallery");
    if (host && window.MutationObserver) new MutationObserver(function () { paintBlur(); }).observe(host, { childList: true, subtree: true, attributes: true, attributeFilter: ["src", "srcset"] });
    setTimeout(paintBlur, 600); setTimeout(paintBlur, 1800);
  }

  /* ---------- 2. barra aggiungi-al-carrello (mobile) ---------- */
  function stickyAtc() {
    var real = document.querySelector('.product-form__submit') || document.querySelector('[name="add"]');
    if (!real || document.querySelector(".rbl-atc")) return;
    var bar = document.createElement("div");
    bar.className = "rbl-atc";
    bar.innerHTML = '<span class="rbl-atc__t"><span class="rbl-atc__n"></span><span class="rbl-atc__p"></span></span><button type="button" class="rbl-atc__b"></button>';
    var nameEl = bar.querySelector(".rbl-atc__n"), priceEl = bar.querySelector(".rbl-atc__p"), btn = bar.querySelector(".rbl-atc__b");
    var h1 = document.querySelector(".product__title h1") || document.querySelector(".product__title") || document.querySelector("h1");
    nameEl.textContent = h1 ? h1.textContent.trim() : "";
    function sync() {
      var p = document.querySelector(".price__container .price-item--sale") || document.querySelector(".price__container .price-item--regular") || document.querySelector(".price-item");
      priceEl.textContent = p ? p.textContent.trim() : "";
      btn.textContent = (real.textContent || "Aggiungi al carrello").trim();
      if (real.disabled) { btn.setAttribute("disabled", "disabled"); } else { btn.removeAttribute("disabled"); }
    }
    sync();
    btn.addEventListener("click", function () { real.click(); });
    document.body.appendChild(bar);
    var pc = document.querySelector(".price") || document.querySelector(".product__info-container");
    if (pc && window.MutationObserver) new MutationObserver(sync).observe(pc, { childList: true, subtree: true, characterData: true });
    function toggle() { bar.classList.toggle("is-on", real.getBoundingClientRect().bottom < 0); }
    window.addEventListener("scroll", toggle, { passive: true });
    window.addEventListener("resize", toggle);
    toggle();
  }

  /* ---------- 3. zoom a schermo intero (solo touch) ---------- */
  function zoom() {
    if (!isTouch || !onPDP || document.getElementById("rbl-zoom")) return;
    var z = document.createElement("div");
    z.id = "rbl-zoom";
    z.innerHTML = '<img alt=""><button class="rbl-z-x" type="button" aria-label="Chiudi">&#215;</button><span class="rbl-z-hint">Pizzica o doppio tap per ingrandire</span>';
    document.body.appendChild(z);
    var zi = z.querySelector("img");
    var sc = 1, tx = 0, ty = 0, st = 1, sx = 0, sy = 0, d0 = 0, lastTap = 0;
    function apply() { zi.style.transform = "translate(" + tx + "px," + ty + "px) scale(" + sc + ")"; }
    function dist(t) { var dx = t[0].clientX - t[1].clientX, dy = t[0].clientY - t[1].clientY; return Math.sqrt(dx * dx + dy * dy) || 1; }
    function open(src) { zi.src = src; sc = 1; tx = 0; ty = 0; apply(); z.classList.add("is-on"); document.documentElement.style.overflow = "hidden"; }
    function close() { z.classList.remove("is-on"); document.documentElement.style.overflow = ""; }
    z.querySelector(".rbl-z-x").addEventListener("click", close);
    z.addEventListener("click", function (e) { if (e.target === z && sc <= 1.02) close(); });
    document.addEventListener("click", function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      var im = t.closest("media-gallery .product__media img");
      if (!im) return;
      e.preventDefault(); e.stopPropagation();
      var src = im.currentSrc || im.src;
      open(src.replace(/([?&])width=\d+/, "$1width=1600"));
    }, true);
    z.addEventListener("touchstart", function (e) {
      if (e.touches.length === 2) { d0 = dist(e.touches); st = sc; return; }
      if (e.touches.length === 1) {
        sx = e.touches[0].clientX - tx; sy = e.touches[0].clientY - ty;
        var now = Date.now();
        if (now - lastTap < 300) { sc = sc > 1.02 ? 1 : 2.4; tx = 0; ty = 0; apply(); lastTap = 0; } else { lastTap = now; }
      }
    }, { passive: true });
    z.addEventListener("touchmove", function (e) {
      if (e.touches.length === 2) { e.preventDefault(); sc = Math.min(5, Math.max(1, st * dist(e.touches) / d0)); apply(); return; }
      if (e.touches.length === 1 && sc > 1.02) { e.preventDefault(); tx = e.touches[0].clientX - sx; ty = e.touches[0].clientY - sy; apply(); }
    }, { passive: false });
    z.addEventListener("touchend", function () { if (sc <= 1.02) { sc = 1; tx = 0; ty = 0; apply(); } });
  }

  /* ---------- 4. conferma aggiunta al carrello ---------- */
  function celebrate() {
    var t = document.getElementById("rbl-toast");
    if (!t) {
      t = document.createElement("div"); t.id = "rbl-toast"; t.textContent = "Aggiunto al carrello"; document.body.appendChild(t);
    }
    var h = document.getElementById("rbl-heart");
    if (!h) {
      h = document.createElement("div"); h.id = "rbl-heart";
      h.innerHTML = '<div class="rbl-h"><svg viewBox="0 0 100 100" aria-hidden="true"><path fill="#A9714B" d="M50 88C24 70 8 55 8 37 8 24 18 14 31 14c8 0 15 4 19 10 4-6 11-10 19-10 13 0 23 10 23 23 0 18-16 33-42 51z"/></svg><span>Grazie</span></div>';
      document.body.appendChild(h);
    }
    requestAnimationFrame(function () { t.classList.add("is-on"); });
    h.classList.remove("is-on"); void h.offsetWidth; h.classList.add("is-on");
    clearTimeout(window.__rblT); window.__rblT = setTimeout(function () { t.classList.remove("is-on"); }, 2600);
    clearTimeout(window.__rblH); window.__rblH = setTimeout(function () { h.classList.remove("is-on"); }, 2400);
  }
  var of = window.fetch;
  if (typeof of === "function" && !window.__rblFetchWrapped) {
    window.__rblFetchWrapped = true;
    window.fetch = function () {
      var p = of.apply(this, arguments);
      try {
        var a = arguments[0];
        var u = typeof a === "string" ? a : (a && a.url) || "";
        if (u.indexOf("/cart/add") > -1) { p.then(function (r) { if (r && r.ok) celebrate(); }).catch(function () {}); }
      } catch (e) {}
      return p;
    };
  }

  /* ---------- 5. sticky colonna info: solo se ci sta ---------- */
  function stickyInfo() {
    var info = document.querySelector(".product .product__info-wrapper");
    if (!info) return;
    function check() {
      var fits = window.innerWidth >= 990 && info.scrollHeight <= window.innerHeight - 60;
      info.classList.toggle("rbl-sticky-ok", fits);
    }
    check();
    window.addEventListener("resize", check);
    setTimeout(check, 900);
  }

  function init() { watchBlur(); if (onPDP) { stickyAtc(); zoom(); stickyInfo(); } }
  if (document.readyState === "loading") { document.addEventListener("DOMContentLoaded", init); } else { init(); }
  document.addEventListener("shopify:section:load", init);
})();
